import AbstractSection from "../AbstractSection";
import { withFormControl } from "puzzle";
import { config } from './DefaultSection.config';


class DefaultSection extends AbstractSection {
  static defaultProps = {
    moduleName: 'AbstractSection'
  };
}

export default withFormControl(config)(DefaultSection)
